<template>

    <div v-if="league && detailData" class="league">
        <LeagueSubNavigation v-if="dataReady" @reinit="init" :league="league" :season="seasonInfo" :baseUrl="baseUrl" :otherSeasons="detailData.seasons"></LeagueSubNavigation>

        <div class="container"  v-if="league.map_image">
            <div class="grid justify-center">
                <div class="col-md-6 col-sm-8 map">
                    <img :src="baseUrl + league.map_image.meta.download_url" :alt="league.map_image.title" />
                </div>
            </div>
        </div>


    </div>

</template>

<script>
import LeagueSubNavigation from '@/components/LeagueSubNavigation.vue';

export default {
    name: 'LeagueMapView',
    components: {
        LeagueSubNavigation,
    },
    data() {
        return {
            leagueId: null,
            league: null,
            competitions: null,
            seasonInfo: null,
            detailData: null,
            dataReady: false,
        }
    },
    mounted () {
        this.init(this.$route.params.id);
    },
    unmounted () {
        document.body.classList.remove('league');
    },
    methods: {
        init(leagueId) {
            this.dataReady = false;
            document.body.classList.add('league');
            this.leagueId = parseInt(leagueId);
            this.$store.dispatch("fetchCompetitions").then( () => {
                this.competitions = this.$store.getters.getCompetitions;
                this.league = this.competitions.find(el => el.id == this.leagueId);
                
                if (this.league) {
                    this.$store.dispatch("fetchData",  {filename: "leagues/league_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                        this.detailData = res;
                        var season_key = this.league.fmpSeasonId;
                        this.seasonInfo = this.detailData.seasons.find(s => s.fmpSeasonId == season_key);

                        this.$nextTick(() => { this.dataReady = true });

                    });
                }
            });
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.init(to.params.id);
        next();
    },
    computed: {
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>

<style  scoped>
.map img {
    max-width: 100%;
    padding: 20px;
}
</style>